import {makeStyles} from "@mui/styles";

const useStyles = makeStyles(theme => ({
    img: {
        width: '100%',
    },
    origin: {
        maxWidth: '120px',
        fontWeight: 'bold',
        top: '-5px',
    },
    title: {
        position: 'absolute',
        width: '100%',
        top: '-5px',
        textAlign: 'center',
        fontWeight: 'bold',
    },
    destination: {
        maxWidth: '120px',
        fontWeight: 'bold',
        top: '-5px',
    },
}));

export default useStyles;